import React from 'react'
import { hydrateRoot } from 'react-dom/client'

import ModalSSR from './views/ModalSSR'
import { Provider } from '../configs/state.manager'
import { I18nextProvider, i18nConfig } from '../internationalization/src'

try {
    const preloadedState = window.__PRELOADED_STATE__
    delete window.__PRELOADED_STATE__

    const {
        orgId,
        orgUnitId,
        lang,
        location,
        quoteId,
        vehicleId,
        newCarTrimId,
        calculatorId,
        hasShowroomWidgets,
        calculatorCtaVersion,
        vehicleCategory,
        isStandaloneVLP,
    } = preloadedState || {}

    hydrateRoot(
        document.getElementById(calculatorId),
        <I18nextProvider i18n={i18nConfig}>
            <React.Suspense fallback={<div />}>
                <Provider
                    orgId={orgId}
                    orgUnitId={orgUnitId}
                    lang={lang}
                    location={location}
                    quoteId={quoteId}
                    vehicleId={vehicleId}
                    newCarTrimId={newCarTrimId}
                    hasShowroomWidgets={hasShowroomWidgets}
                    calculatorCtaVersion={calculatorCtaVersion}
                    vehicleCategory={vehicleCategory}
                    isStandaloneVLP={isStandaloneVLP}
                >
                    <ModalSSR />
                </Provider>
            </React.Suspense>
        </I18nextProvider>
    )
} catch (e) {
    console.error(e)
}

if (module.hot) {
    module.hot.accept()
}
